import { MLPVersion } from '@nextgen-web-framework/all';
import {
  KeyboardEvent as ReactKeyboardEvent,
  MouseEvent as ReactMouseEvent,
  TouchEvent as ReactTouchEvent,
} from 'react';

/**
 * Props for otp verification component
 * @date 11/11/2023 - 12:24:01 pm
 *
 * @export
 * @interface OtpVerificationProps
 * @typedef {OtpVerificationProps}
 */
export interface OtpVerificationProps {
  /**
   * Challenge Id generated for specific use case for which we are trying to verify otp
   * @date 11/11/2023 - 12:24:01 pm
   *
   * @type {string}
   */
  challengeId: string;
  /**
   * username on which otp needs to be sent (could be email/ phone)
   * @date 11/11/2023 - 12:24:01 pm
   *
   * @type {string}
   */
  username: string;
  /**
   * onClose function to  be executed on click of close icon
   * @date 11/11/2023 - 12:24:01 pm
   *
   * @type {function}
   */
  onClose: (e: ReactKeyboardEvent | ReactMouseEvent | ReactTouchEvent) => void;
  /**
   * Callback function to be executed after successful verification
   * @date 11/11/2023 - 12:24:01 pm
   *
   * @type {?() => void}
   */
  callback?: () => void;
  /**
   * flag for autoverification of otp
   * @date 11/11/2023 - 12:24:00 pm
   *
   * @type {?boolean}
   */
  autoverify?: boolean;
  /**
   * if username changing link is needed
   * @date 11/11/2023 - 12:24:00 pm
   *
   * @type {?boolean}
   */
  showChangeCTA?: boolean;
  /**
   * mlp version number to use variants
   * @date 11/11/2023 - 12:24:00 pm
   *
   * @type {?MLPVersion}
   */
  mlpVersion?: MLPVersion;
  /**
   * onChangeCTA function to  be executed on click of ChangeCTA Link (applicable only if showChangeCTA is true)
   * @date 11/11/2023 - 12:24:01 pm
   *
   * @type {function}
   */
  onChangeCTA?: (e: ReactKeyboardEvent | ReactMouseEvent | ReactTouchEvent) => void;
  showLabelForForgotPassword?: boolean;
  usernameType?: UsernameType;
}

export enum UsernameType {
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
}

export interface VerifyCodeFormInitialValue {
  otp: string;
}
